function handleResize() {
    var screenSize = window.innerWidth;
    if (screenSize < 980) {
        $('.ib-custom').removeClass('ib-slice').addClass('ib-slider');
    } else {
        $('.ib-custom').removeClass('ib-slider').addClass('ib-slice');
    }
}
// Ensure handleResize is accessible globally
handleResize();

$(window).resize(function() {
    handleResize();
});

if (!$('.ib-custom .product').length == 0) {
    $('.ib-custom .product').each(function() {
        // Check if the div does not contain an anchor tag
        if ($(this).find('a').length == 0) {
            // Remove the div
            $(this).remove();
        }
    });

    $(".ib-slice").slice(0, 4).show();

    $("#ib-load-more").on("click", function(e) {
        e.preventDefault();
        $(".product:hidden").slice(0, 4).slideDown();
        if ($(".ib-slice .product:hidden").length == 0) {
            $("#ib-load-more").css("display", "none");
        }
    });

    var count = 0;
    $('.ib-slice .product').each(function(index, element) {
        var outerHtmlContent = $(element).prop('outerHTML');
        var innerHtmlContent = $(element).html().trim();
        if (innerHtmlContent !== '') {
            count++;
        }
    });

    if (count <= 4) {
        $("#ib-load-more").css("display", "none");
    }
}

/* After Insertion using MutationObserver */
var targetNode = document.querySelector('.ib-custom');

var config = { childList: true, subtree: true };

var callback = function(mutationsList, observer) {
    mutationsList.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
            setTimeout(function() {
                $('.ib-custom .product').each(function() {
                    // Check if the div does not contain an anchor tag
                    if ($(this).find('a').length == 0) {
                        // Remove the div
                        $(this).remove();
                    }
                });

                $(".ib-slice").slice(0, 4).show();

                $("#ib-load-more").on("click", function(e) {
                    e.preventDefault();
                    $(".product:hidden").slice(0, 4).slideDown();
                    if ($(".ib-slice .product:hidden").length == 0) {
                        $("#ib-load-more").css("display", "none");
                    }
                });

                handleResize();

                var count = 0;
                $('.ib-slice .product').each(function(index, element) {
                    var outerHtmlContent = $(element).prop('outerHTML');
                    var innerHtmlContent = $(element).html().trim();
                    if (innerHtmlContent !== '') {
                        count++;
                    }
                });

                if (count <= 4) {
                    $("#ib-load-more").css("display", "none");
                }
            }, 1000);
        }
    });
};

var observer = new MutationObserver(callback);
observer.observe(targetNode, config);





// Product Add to cart btn
window.addEventListener('DOMContentLoaded', function() {
    var section = document.querySelector('.for-sticky-cartbtn');
    var button = document.querySelector('.ib-sh-cartbuttonsticky');
    if (!section || !button) return;  // Exit if elements are not found

    var sectionBounds = section.getBoundingClientRect();
    // Initial check
    if (sectionBounds.bottom <= window.innerHeight + 150) {
        button.classList.remove('ibat-sticky-btn');
    } else {
        button.classList.add('ibat-sticky-btn');
    }

    window.addEventListener('scroll', function() {
        var sectionBounds = section.getBoundingClientRect();
        // Show the button when the section is about to disappear
        if (sectionBounds.bottom <= window.innerHeight + 150) {
            button.classList.remove('ibat-sticky-btn');
        } else {
            setTimeout(function() {
                var sectionBounds1 = section.getBoundingClientRect();
                if (!(sectionBounds1.bottom <= window.innerHeight + 150)) {
                    button.classList.add('ibat-sticky-btn');
                }
            }, 100);
        }
    });
});
